<cm-inspector-section>
    <ng-container cm-title>{{ $class() }}</ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'name'" [schema]="componentSchema" [overwrittenValue]="$component()" [label]="'Component'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'outputId'" [label]="'Output'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
